import { useModal } from '@ebay/nice-modal-react';
import { useEffect } from 'react';

import useMatrixDeviceVerificationContext from 'contexts/MatrixDeviceVerificationContext/useMatrixDeviceVerificationContext';

import IncomingSasVerificationRequestModal from './IncomingSasVerificationRequestModal';
import WaitingForSasVerificationModal from './WaitingForSasVerificationModal';

const SasVerificationManager = () => {
  const { shouldShowIncomingModal, shouldShowWaitingModal } = useMatrixDeviceVerificationContext();
  const incomingSasVerificationRequestModal = useModal(IncomingSasVerificationRequestModal);
  const waitingForSasVerificationModal = useModal(WaitingForSasVerificationModal);

  useEffect(() => {
    shouldShowWaitingModal ? waitingForSasVerificationModal.show() : waitingForSasVerificationModal.remove();
  }, [shouldShowWaitingModal, waitingForSasVerificationModal]);

  useEffect(() => {
    shouldShowIncomingModal ? incomingSasVerificationRequestModal.show() : incomingSasVerificationRequestModal.remove();
  }, [shouldShowIncomingModal, incomingSasVerificationRequestModal]);

  return null;
};

export default SasVerificationManager;
